import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';
import { queryClient } from '$/services/client';

export const AdminInspirationsRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/inspirations',
  onEnter: async () => {
    await queryClient.invalidateQueries({ queryKey: ['brandCountries'] });
    await queryClient.invalidateQueries({ queryKey: ['adminOptions'] });
  },
}).lazy(() => import('./AdminInspirationsRoute.lazy').then((d) => d.Route));
